if (document.getElementById('page-works')) {
  page()
}

function page() {
  // WORKSページ
  initWorksVideo()
}

function initWorksVideo() {
  const movieContainers = document.querySelectorAll('.js-works-movie')
  if (movieContainers.length === 0) {
    return
  }

  const videoData = []

  movieContainers.forEach((container) => {
    const video = container.querySelector('video')
    const playButton = container.querySelector('.js-movie-play')
    const playButtonWrapper = container.querySelector('.js-movie-playwrap')

    if (!video || !playButton || !playButtonWrapper) {
      return
    }

    // Save video data to array
    videoData.push({
      video,
      playButton,
      playButtonWrapper,
      container,
    })

    // Toggle Play Button
    const togglePlayButton = (show) => {
      if (show) {
        playButtonWrapper.style.display = 'flex'
      } else {
        playButtonWrapper.style.display = 'none'
      }
    }

    // Hide button
    if (!video.paused) {
      togglePlayButton(false)
    }

    playButton.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      video.play()
    })

    video.addEventListener('play', () => {
      togglePlayButton(false)
      // Pause all other videos
      pauseOtherVideos(video, videoData)
    })

    // Show button
    video.addEventListener('pause', () => {
      togglePlayButton(true)
    })
  })
}

/**
 * Pause all other videos
 * @param {HTMLVideoElement} currentVideo Current video
 * @param {Array} videoData All video data array
 */
function pauseOtherVideos(currentVideo, videoData) {
  videoData.forEach((data) => {
    if (data.video !== currentVideo && !data.video.paused) {
      data.video.pause()
    }
  })
}
